import React, { PureComponent } from 'react'
import { CloseOutline16 } from '@carbon/icons-react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './index.scss'
import { uniqueId } from 'lodash'

export default class Tab extends PureComponent {
  static propTypes = {
    /** Tab title */
    title: PropTypes.string,
    selected: PropTypes.bool,
    /** Tab content */
    children: PropTypes.node,
    /** Tab has a close button */
    closable: PropTypes.bool,
    /** Optional component that will be rendered on the right of the title tab */
    rightComponent: PropTypes.elementType,
    id: PropTypes.string
  }

  render() {
    const {
      selected,
      closable,
      title,
      onClick,
      onClose,
      index,
      rightComponent: RightComponent,
      id
    } = this.props
    const renderID = (id) => {
      // tentativo di recuperare id per il tabs per il momento il new compare
      // sia per il new reale che per l'editing TODO
      if (typeof id === 'string') {
        const splitID = id?.split(':')

        return splitID?.length === 3 && splitID[2].split('new_').length > 1
          ? uniqueId('new_' + splitID[0] + '_')
          : id || 'tabs_TBD_' + uniqueId()
      }
      // per identificare dove modificare la logica
      return 'tabs_TBD_' + uniqueId()
    }

    return (
      <li
        role='tab'
        tabIndex={index}
        className={cx(
          'ublique-tabs__tab',
          'bx--tabs__nav-item',
          selected && 'bx--tabs__nav-item--selected'
        )}
        id={'BDD_' + renderID(id)}
        aria-selected={selected}
        onClick={onClick}
      >
        <a className='bx--tabs__nav-link' tabIndex={index}>
          <span title={title} className='bx--tabs__nav-link-title'>
            <span className='title-text'>{title}</span>
            {RightComponent && (
              <span className='title-right-component'>
                <RightComponent />
              </span>
            )}
          </span>
          {closable && (
            <div className='bx--tabs__nav-item__close-button' onClick={onClose}>
              <CloseOutline16 />
            </div>
          )}
        </a>
      </li>
    )
  }
}
